/**
 * Hotel ids in routes previously used btoa()/atob().
 * Client expects the plain origin/doc_id in URLs and tracking.
 */

/** Plain origin/doc_id for route segments and Meta content_ids (no encryption). */
export function toRouteHotelId(id: string | number | null | undefined): string {
  if (id == null) {
    return '';
  }
  return String(id).trim();
}

/**
 * Read a hotel (or location) id from a route param.
 * Supports legacy base64-encoded values and plain origin/doc_ids.
 */
export function fromRouteHotelId(param: string | null | undefined): string {
  if (param == null) {
    return '';
  }

  let raw = String(param).trim();
  if (!raw) {
    return '';
  }

  try {
    raw = decodeURIComponent(raw);
  } catch {
    // already decoded or malformed — keep raw
  }

  const legacy = tryDecodeLegacyBase64Id(raw);
  return legacy || raw;
}

/** If value is legacy btoa output, return the plain origin id; otherwise null. */
function tryDecodeLegacyBase64Id(value: string): string | null {
  if (!/^[A-Za-z0-9+/]+={0,2}$/.test(value)) {
    return null;
  }

  try {
    const decoded = atob(value);
    // Round-trip + shorter decoded form distinguishes real ids from coincidental base64.
    if (
      decoded &&
      btoa(decoded) === value &&
      decoded.length > 0 &&
      decoded.length < value.length &&
      /^[\x20-\x7E]+$/.test(decoded)
    ) {
      return decoded.trim();
    }
  } catch {
    // not legacy base64
  }

  return null;
}
